import { RootState } from '../../store';
import { locale, currency } from './core';
import { createSelector } from '@reduxjs/toolkit';
import { Price } from '@fixtuur/backpack';

const state = (state: RootState) => state.basket;

export const price = createSelector([state, locale, currency], (state, locale, currency) => {
    return state.basket ? Price.toLocaleString(state.basket.price, locale, currency) : undefined;
});

export const basket = createSelector(state, state => state.basket);

export const products = createSelector(state, state => state.basket?.products);

export const items = createSelector(state, state => {
    return state.basket?.products.map(p => p.productId);
});
